module.exports = __webpack_public_path__ + "img/ctrl-rx-theta-1.bc31dee2.svg";